import { tw } from "@/utils";
import IncreaseNumber from "./assets/increaseNumber.svg?react";
import DecreaseNumber from "./assets/decreaseNumber.svg?react";

interface BedChangeIconProps {
  change: number;
}

export const BedChangeIcon = (props: BedChangeIconProps) => {
  const { change } = props;

  return (
    <div
      className={tw(
        "flex items-center justify-center gap-[4px]",
        "min-w-[42px] h-[24px] px-[4px] rounded-[6px]",
        "text-sm font-semibold",
        colorClassName(change)
      )}
    >
      {change > 0 && (
        <>
          {`+${change}`}
          <IncreaseNumber />
        </>
      )}
      {change === 0 && `-`}
      {change < 0 && (
        <>
          {change}
          <DecreaseNumber />
        </>
      )}
    </div>
  );
};

const colorClassName = (change: number) => {
  if (change > 0) {
    return "bg-green/10 text-green";
  } else if (change < 0) {
    return "bg-red/10 text-red";
  } else {
    return "bg-gray-g30 text-gray-g200";
  }
};
